import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/cxaSnpKPJn8?si=fuYqFkIEip64fi5T"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/ktdDO3VUdSc?si=cnM6VklaQdpvkCan"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/DaVIueszNIg?si=jzoo_A8S-ekEHPm5"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/E23favZuFXk?si=apRRLBXxJPgum4lw"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/9Gye-3v2M9g?si=KomzkfpNLDEhvU6U"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
];

function ResortProduction() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Resort Productions"
        para="Indulge in luxury and relaxation with our Hotel & Resort Video Production playlist! 
Join us as we whisk you away to stunning destinations and lavish accommodations around the world. From tranquil spa retreats to vibrant beachfront resorts, our videos capture the essence of each property, highlighting their unique charm and amenities. Whether you're planning your next vacation or seeking inspiration for your dream getaway, our videos offer a glimpse into the ultimate in hospitality and leisure. 
"
      />
      <VideoCareer videos={videos} />

      {/* <FourthPage /> */}
    </div>
  );
}

export default ResortProduction;
